import { AuthErrorKeys, useAuthService } from '@b2ag/auth'
import { Route } from 'vue-router'
import { isRouteAuthorized } from '@invivodf/front-seller-auth/src/isRouteAuthorized'
import store from '@/store'
import { useScopesService } from '@/auth/useScopes'

const AUTHENTICATION_NOT_REQUIRED_ROUTES = ['oauth-callback', 'not-found']

export async function b2agRouterBeforeEach(to: Route, from: Route, next) {
  if (AUTHENTICATION_NOT_REQUIRED_ROUTES.includes(to.name!)) return next()
  if (to.name === 'auth-callback-error') return next()
  const authService = useAuthService()
  let isAuthenticated = await authService.isAuthenticated()
  if (!isAuthenticated) {
    try {
      await authService.checkUserAuthSession()

      isAuthenticated = await authService.isAuthenticated()
    } catch (error: any) {
      console.warn('not authenticated, attempting a login')
      if (error.message === AuthErrorKeys.IS_NOT_AUTHENTICATED) {
        await authService.login()
        return false
      }
      return next({ name: 'auth-callback-error', query: { error_code: error.message } })
    }
  } else {
    const scopesService = useScopesService()
    let userScopes: string[]
    try {
      userScopes = (await authService.getScopes()) ?? []
    } catch (error: any) {
      // Silent token renewal hits the Auth0 session shared across brand fronts: it can be expired
      // (login_required) or belong to a non-seller account (Auth0 Action "not-allowed" denial).
      console.warn('could not renew user session')
      if (error.error === 'login_required' || error.message === AuthErrorKeys.IS_NOT_AUTHENTICATED) {
        await authService.login()
        return false
      }
      return next({ name: 'auth-callback-error', query: { error_code: error.message } })
    }
    try {
      scopesService.validateScopes(userScopes)
    } catch (err) {
      console.warn('scopes not validated, logging out')
      await authService.logout()
      return false
    }

    const isAuthorized = await isRouteAuthorized(to)

    if (!isAuthorized) return false

    // eslint-disable-next-line import/no-named-as-default-member, prefer-destructuring
    const isUserLoaded = store.getters.isUserLoaded

    if (isAuthenticated && !isUserLoaded) {
      await store.dispatch('fetchUser')
      await store.dispatch('setPartnerWithNewOfferConfiguration')
    }
    return next()
  }
  return false
}
